<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-hourglass title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{ 'model.sequences' | transloco }}</p>
        <p>{{ 'menu.descriptions.sequences' | transloco }}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [label]="'common.new' | transloco"
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                icon="pi pi-plus"
                pButton
                pRipple
                routerLink="new"
              ></button>
              <button
                (click)="confirmAndDeleteSelected()"
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [disabled]="selected.length == 0"
                [label]="'common.delete' | transloco"
                class="p-button-danger mb-2 sm:mb-0"
                icon="pi pi-trash"
                pButton
                pRipple
              ></button>
            </div>
            <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                (click)="filtersVisible = !filtersVisible"
                [label]="'common.filters' | transloco"
                class="p-button-secondary"
                icon="pi pi-sliders-h"
                pButton
              ></button>
            </div>
            <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                (click)="filtersVisible = !filtersVisible"
                [label]="'common.filters' | transloco"
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
                pButton
              ></button>
            </div>
          </div>
        </div>
        <p-table
          (onLazyLoad)="onPageChange($event)"
          [(first)]="first"
          [(rows)]="rows"
          [(selection)]="selected"
          [lazy]="true"
          [paginator]="true"
          [responsive]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [totalRecords]="totalSequences"
          [value]="sequences"
          sortField="name"
          styleClass="p-datatable-striped p-datatable-overflow"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="selection-column-width" scope="col"></th>
              <th pSortableColumn="name" scope="col">
                {{ 'attribute.name' | transloco }}
                <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th *ngIf="'ROLE_SUPER_ADMIN' | userHasRole" pSortableColumn="tenant.name" scope="col">
                {{ 'model.tenant' | transloco }}
                <p-sortIcon field="tenant.name"></p-sortIcon>
              </th>
              <th *ngIf="'ROLE_ADMIN' | userHasRole" pSortableColumn="organization.name" scope="col">
                {{ 'model.organization' | transloco }}
                <p-sortIcon field="organization.name"></p-sortIcon>
              </th>
              <th pSortableColumn="currentStage" scope="col">
                {{ 'model.currentStep' | transloco }}
                <p-sortIcon field="currentStage"></p-sortIcon>
              </th>
              <th pSortableColumn="state" scope="col">
                {{ 'model.states' | transloco }}
                <p-sortIcon field="state"></p-sortIcon>
              </th>
              <th pSortableColumn="nextActivation" scope="col">
                {{ 'model.nextActivation' | transloco }}
                <p-sortIcon field="nextActivation"></p-sortIcon>
              </th>
              <th class="w-10rem text-center" scope="col">
                {{ 'common.actions' | transloco }}
              </th>
            </tr>
          </ng-template>
          <ng-template let-sequence pTemplate="body">
            <tr *ngIf="!loadingSequences" class="fadein">
              <td>
                <span class="p-column-title bold">{{ 'common.select' | transloco }}</span>
                <p-tableCheckbox [value]="sequence"></p-tableCheckbox>
              </td>
              <td>
                <span class="p-column-title bold">{{ 'attribute.name' | transloco }}</span>
                {{ sequence.name }}
              </td>
              <td *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{ 'model.tenant' | transloco }}</span>
                {{ sequence.tenant.name }}
              </td>
              <td *ngIf="'ROLE_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{ 'model.organization' | transloco }}</span>
                {{ sequence?.organization?.name }}
              </td>
              <td>
                <span class="p-column-title bold">{{ 'model.currentStage' | transloco }}</span>
                {{ sequence?.currentStage }}
              </td>
              <td>
                <span class="p-column-title bold">{{ 'model.states' | transloco }}</span>
                <p-tag [class]="getStateSeverity(sequence.status)" styleClass="w-full">
                  {{ getStateTranslation(sequence.status) }}
                </p-tag>

              </td>
              <td>
                <span class="p-column-title bold">{{ 'model.nextActivation' | transloco }}</span>
                {{ sequence?.nextActivation | customDate }}
              </td>
              <td>
                <span class="p-column-title bold">{{ 'common.actions' | transloco }}</span>
                <div class="flex justify-content-end">
                  <button
                    (click)="openSubscription(sequence.uuid)"
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-bell"
                    pButton
                    pRipple
                  ></button>
                  <button
                    (click)="executeSequence(sequence)"
                    *ngIf="'ROLE_ADMIN' | userHasRole"
                    [icon]="'pi pi-play'"
                    class="p-button-rounded btn-primary-light mr-2"
                    pButton
                    pRipple
                    [disabled]="!canExecute(sequence)"
                  ></button>
                  <button
                    (click)="restartSequence(sequence)"
                    *ngIf="'ROLE_ADMIN' | userHasRole"
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-replay"
                    pButton
                    pRipple
                    [disabled]="!canRestore(sequence)"
                  ></button>
                  <button
                    *ngIf="'ROLE_ADMIN' | userHasRole"
                    [routerLink]="[sequence.uuid, 'edit']"
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                    pButton
                    pRipple
                    [disabled]="!canUpdate(sequence)"
                  ></button>
                  <button
                    (click)="downloadSequence(sequence.uuid, sequence.name)"
                    *ngIf="'ROLE_ADMIN' | userHasRole"
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-download"
                    pButton
                    pRipple
                  ></button>
                  <button
                    (click)="confirmAndDelete(sequence.uuid)"
                    *ngIf="'ROLE_ADMIN' | userHasRole"
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                    pButton
                    pRipple
                    [disabled]="!canDelete(sequence)"
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingSequences" class="fadein animation-delay-100 animation-fill-forwards no-opacity">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton *ngIf="'ROLE_SUPER_ADMIN' | userHasRole" height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton *ngIf="'ROLE_ADMIN' | userHasRole" height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="totalSequences === 0" class="flex align-items-center justify-content-between">
              {{ 'pagination.empty' | transloco }}
            </div>
            <div *ngIf="totalSequences > 0" class="flex align-items-center justify-content-between">
              {{ 'pagination.showing' | transloco }} {{ first + 1 }}
              {{ 'pagination.to' | transloco }} {{ (first + rows) >= totalSequences ? totalSequences : (first + rows) }}
              {{ 'pagination.of' | transloco }} {{ totalSequences }}
              {{ (totalSequences > 1 ? 'pagination.entries' : 'pagination.entry') | transloco }}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right" [blockScroll]="true">
  <h2 style="margin-left: 10px">{{ 'common.filters' | transloco }}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{ 'attribute.name' | transloco }}</label>
      </div>
      <div class="col-12 form-field">
        <input
          (keyup.enter)="filtersVisible = false; applyFilters()"
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          appAutoFocus
          class="w-full"
          id="name"
          pInputText
          type="text"
        >
      </div>
    </div>
    <div *ngIf="authGuardService.superAdminRequired()" class="col-12">
      <div class="col-12 form-field">
        <label for="tenant">{{ 'model.tenant' | transloco }}</label>
      </div>
      <div class="col-12">
        <p-multiSelect
          (onChange)="filteredOrganizations()"
          [(ngModel)]="currentFilters.tenantUuids"
          [filter]="true"
          [options]="tenants"
          [placeholder]="'select.tenant' | transloco"
          appendTo="body"
          display="chip"
          filterBy="name"
          id="tenant"
          optionLabel="name"
          optionValue="uuid"
          styleClass="w-full"
        ></p-multiSelect>
      </div>
    </div>
    <div *ngIf="'ROLE_ADMIN' | userHasRole: false" class="col-12">
      <div class="col-12 form-field">
        <label for="organization">{{ 'model.organization' | transloco }}</label>
      </div>
      <div class="col-12">
        <p-multiSelect
          [(ngModel)]="currentFilters.organizationUuids"
          [disabled]="tenantFilterChanged"
          [filter]="true"
          [options]="organizations"
          [placeholder]="'select.organization' | transloco"
          appendTo="body"
          display="chip"
          filterBy="name"
          id="organization"
          optionLabel="name"
          optionValue="uuid"
          styleClass="w-full"
        ></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="tenant">{{ 'attribute.state' | transloco }}</label>
      </div>
      <div class="col-12">
        <p-dropdown
          [(ngModel)]="currentFilters.state"
          [autoDisplayFirst]="false"
          [options]="stateOptions"
          [placeholder]="'select.state' | transloco"
          [showClear]="true"
          appendTo="body"
          id="sequenceState"
          optionLabel="label"
          optionValue="value"
          styleClass="w-full"
        >
          <ng-template let-item pTemplate="selectedItem">
            {{ item.label | transloco }}
          </ng-template>
          <ng-template let-item pTemplate>
            {{ item.label | transloco }}
          </ng-template>
        </p-dropdown>
      </div>
    </div>
    <div class="col-12">
      <p-button
        (onClick)="filtersVisible = false; applyFilters();"
        [disabled]="!(
          currentFilters.name ||
          currentFilters.tenantUuids ||
          currentFilters.organizationUuids ||
          currentFilters.state
        )"
        [label]="'common.filter' | transloco"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        (click)="resetFilters(); filtersVisible = false;"
        [label]="'common.clear' | transloco"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>

<app-sequence-subscription-input></app-sequence-subscription-input>
